
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import t from "@common/src/i18n/t";

const store = namespace("store");
const user = namespace("user");

@Component({})
export default class SettlementTablePrint extends Vue {
  @store.State storeData;
  @user.State userData;
  @Prop({ default: () => ({}), type: Object })
  orderData: any;
  @Prop({ default: () => [], type: Array })
  fieldList: any;
  @Prop({ default: "13012345678", type: String })
  templateServicePhone: string;
  @Prop({ default: t("v216_6.sample-store-information-store"), type: String })
  storeNameBySource: string;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get $orderData() {
    const fullRowNum =
      7 - (this.orderData.allOrderDetail?.service.length || 0) - (this.orderData.allOrderDetail?.parts.length || 0);
    if (fullRowNum > 0) {
      const fullArr = Array(fullRowNum).fill({});
      (this.orderData.allOrderDetail.parts || []).push(...fullArr);
    }
    return this.orderData;
  }
  get firstTechnicianName() {
    const itemList = [...this.$orderData.allOrderDetail.service, ...this.$orderData.allOrderDetail.parts];
    const find = itemList.find(item => item.technicianArray?.[0]);
    return find ? find.technicianArray[0].technicianName : "-";
  }
}
